var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrapper"},[_c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":require("@/assets/noInfo.png"),"alt":_vm.emptyText}}),_c('p',[_vm._v(_vm._s(_vm.emptyText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }